import { render, staticRenderFns } from "./menu-management.vue?vue&type=template&id=2309debc&scoped=true&"
import script from "./menu-management.vue?vue&type=script&lang=js&"
export * from "./menu-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2309debc",
  null
  
)

export default component.exports